// Languages & translations (specs 28).
const locEn = {
  "nav.translate": "Translate",
  "settings.languages": "Languages",
  "settings.languages_hint": "Storefront languages, prices and dates",
  "lang.title": "Languages",
  "lang.description": "The languages your storefront speaks. The primary one has no prefix; others live at /ar/, /fr/ and so on.",
  "lang.translate": "Translate content",
  "lang.languages": "Storefront languages",
  "lang.limit": "{n} of {limit} languages on your plan",
  "lang.add": "Add language",
  "lang.added_toast": "Language added. Translate your content, then publish it.",
  "lang.add_hint": "New languages start unpublished, so shoppers don't see half-translated pages.",
  "lang.language": "Language",
  "lang.primary": "Primary",
  "lang.published": "Published",
  "lang.unpublished": "Unpublished",
  "lang.manage": "Manage",
  "lang.publish": "Publish",
  "lang.unpublish": "Unpublish",
  "lang.published_toast": "{name} is live on your storefront",
  "lang.unpublished_toast": "{name} is hidden from shoppers",
  "lang.make_primary": "Make primary",
  "lang.primary_title": "Make {name} the primary language?",
  "lang.primary_body": "It's served at your store's main address, without a prefix. Your products and pages are still edited in the language you wrote them in; translations then fill the others.",
  "lang.primary_toast": "{name} is now the primary language",
  "lang.remove": "Remove",
  "lang.remove_title": "Remove {name}?",
  "lang.remove_body": "Its translations are deleted too. This can't be undone.",
  "lang.removed_toast": "{name} removed",
  "lang.limit_reached": "You've reached your plan's language limit. Upgrade to add more.",
  "lang.formats": "Formats",
  "lang.formats_hint": "How prices, numbers, dates and links appear in each language.",
  "lang.arabic_digits": "Arabic-Indic digits",
  "lang.arabic_digits_hint": "Show ٠١٢٣ instead of 0123 on Arabic pages. Most Gulf shoppers read Latin digits more easily.",
  "lang.hijri": "Hijri dates",
  "lang.hijri_hint": "Show the Hijri date next to the Gregorian one on Arabic pages (blog posts, orders).",
  "lang.handles": "Translated URLs",
  "lang.handles_hint": "Use translated handles in links, like /ar/products/عباية-سوداء. The original links keep working.",
  "lang.money_for": "Prices in {name}",
  "lang.money_hint": "Use {{amount}} for the number. Leave empty for the default.",
  "lang.money_label": "Price format in {name}",
  "lang.money_code_label": "Price with currency code in {name}",
  "lang.arabic_tip": "Most shoppers in the Gulf expect an Arabic storefront. Add Arabic to reach them.",
  "tr.title": "Translate",
  "tr.description": "Translate your store's content into each language. Changed originals are marked outdated.",
  "tr.import": "Import CSV",
  "tr.export": "Export CSV",
  "tr.imported": "{n, plural, one {1 translation imported} other {# translations imported}}, {skipped, plural, one {1 row skipped} other {# rows skipped}}",
  "tr.language": "Language",
  "tr.content": "Content",
  "tr.status": "Status",
  "tr.all": "All",
  "tr.untranslated": "Not translated",
  "tr.outdated": "Outdated",
  "tr.search": "Search",
  "tr.none": "Nothing here.",
  "tr.pick": "Pick something on the left to translate.",
  "tr.n_outdated": "{n} outdated",
  "tr.editing": "Translating into {lang}",
  "tr.auto": "Translate automatically",
  "tr.auto_outdated": "Update outdated",
  "tr.auto_done": "Translated automatically — please review",
  "tr.arabic_review": "Machine translation into Arabic can miss tone and dialect. Read it through before publishing.",
  "tr.nothing": "There's no text to translate here.",
  "tr.outdated_badge": "Outdated",
  "tr.still_correct": "Still correct",
  "tr.handle_hint": "Leave empty to keep the original link",
  "tr.no_languages": "Add a language first",
  "tr.no_languages_body": "Translations need a second storefront language, such as Arabic.",
  "tr.add_language": "Add a language",
  "tr.f.title": "Title",
  "tr.f.body": "Description",
  "tr.f.seo_title": "Search engine title",
  "tr.f.seo_description": "Search engine description",
  "tr.f.handle": "URL handle",
  "tr.f.summary": "Excerpt",
  "tr.f.image_alt": "Image alt text",
  "tr.f.name": "Name",
  "tr.f.description": "Description",
  "tr.f.label": "Label",
  "tr.f.instructions": "Instructions",
  "tr.f.home_title": "Home page title",
  "tr.f.home_description": "Home page description",
  "tr.f.password_message": "Password page message",
  "tr.f.option_name": "Option {n} name",
  "tr.f.option_value": "Option {n} value: {value}",
  "tr.f.menu_item": "Menu item: {name}",
  "tr.type.product": "Products",
  "tr.type.collection": "Collections",
  "tr.type.page": "Pages",
  "tr.type.blog": "Blogs",
  "tr.type.article": "Blog posts",
  "tr.type.menu": "Navigation menus",
  "tr.type.policy": "Policies",
  "tr.type.shop": "Store details",
  "tr.type.theme": "Theme content",
  "tr.type.theme_strings": "Theme texts",
  "tr.type.shipping_rate": "Shipping rates",
  "tr.type.payment_method": "Payment methods",
  "tr.type.search_filter": "Search filters",
};
export default locEn;
